import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { BaseCalc } from "../../baseCalc";
import React from "react";
import { PublicAutoSkeleton } from "./PublicAutoSkeleton";
var PublicAutoLayout = React.lazy(function () { return import(/* webpackChunkName: "public-auto-layout" */ "./PublicAutoLayout"); });
export var PublicAutoCalculator = function (_a) {
    var esiaLink = _a.esiaLink;
    return (_jsx("div", { id: "calculator-block", children: _jsx(Suspense, { fallback: _jsx(PublicAutoSkeleton, {}), children: _jsx(BaseCalc, { esiaLink: esiaLink, Layout: PublicAutoLayout }) }) }));
};
